module.exports = __webpack_public_path__ + "img/logo_title.dea29eaf.png";